import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

export const HeroBanner = (props) => {
  const { t } = useTranslation();
  
  const backgroundStyle = {
    backgroundImage: `url(${props.data ? props.data.backgroundImg : "img/hero-product.png"})`
  };

  // Ensure blur effects are properly displayed
  useEffect(() => {
    // Force repaint of blur effects
    const blurEffects = document.querySelectorAll('#hero-banner .blur-effect');
    blurEffects.forEach(el => {
      el.style.opacity = '1';
      el.style.display = 'block';
    });
  }, []);

  return (
    <div id="hero-banner">
      <div className="hero-container">
        <div className="hero-background">
          <div className="noise-overlay"></div>
          <div className="blur-effect blur-effect-1" style={{opacity: 1, display: 'block'}}></div>
          <div className="blur-effect blur-effect-2" style={{opacity: 1, display: 'block'}}></div>
          <div className="blur-effect blur-effect-3" style={{opacity: 1, display: 'block'}}></div>
          <div className="blur-effect blur-effect-4" style={{opacity: 1, display: 'block'}}></div>
          <div className="hero-content-wrapper">
            <div className="container position-relative">
              <div className="row">
                <div className="col-md-5 position-relative z-index-2">
                  <div className="hero-content">
                    <div className="hero-text">
                      <h1>{t('HeroBanner.title')}</h1>
                      <p>{t('HeroBanner.paragraph')}<br/><br/>{t('HeroBanner.paragraph2')}</p>
                      <div className="hero-buttons desktop-buttons">
                        <a href="#use-cases" className="btn btn-custom btn-lg">{t('HeroBanner.learnMore')}</a>
                        {/* <a href="#use-cases" className="btn btn-outline btn-lg">{t('HeroBanner.learnMore')}</a> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="dashboard-image-container">
                <div className="image-gradient-overlay"></div>
                <img 
                  src="img/portfolio/hadal_dashboard.png" 
                  alt="Hadal Dashboard" 
                  className="dashboard-image" 
                  draggable="false"
                  onContextMenu={(e) => e.preventDefault()}
                  style={{ WebkitTouchCallout: 'none', userSelect: 'none' }}
                />
              </div>
              <div className="mobile-buttons-wrapper">
                <div className="hero-buttons mobile-buttons">
                  <a href="#use-cases" className="btn btn-custom btn-lg">{t('HeroBanner.learnMore')}</a>
                  {/* <a href="#use-cases" className="btn btn-outline btn-lg">{t('HeroBanner.learnMore')}</a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 